<template>
  <div class="accountList">
    <!-- 筛选 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 关键字 -->
        <el-form-item>
          <el-input 
            v-model="keyword"
            :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_keyword')"
            prefix-icon="el-icon-search">
          </el-input>
        </el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true,true)">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <!-- 新增 -->
      <el-button type="primary" slot="header" @click="onAdd">{{$t('lang.btn_add')}}</el-button>
      <!-- 删除 -->
      <el-button type="primary" slot="header" @click="onDelete">{{$t('lang.btn_delete')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_number')" width="100px"></el-table-column>
        <!-- 使用者 -->
        <el-table-column prop="userName" :label="$t('lang.lab_user')" width="180px"></el-table-column>
        <!-- 账号 -->
        <el-table-column prop="accountNumber" :label="$t('lang.lab_account')" width="180px">    
        </el-table-column>
        <!-- 密码 -->
        <el-table-column prop="password" :label="$t('lang.lab_password')">
          <template>
            <span>*******</span>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column prop="accountStatus" :label="$t('lang.lab_isStatus')">
          <template slot-scope="scope">
            <!-- 0: 禁用 -->
            <span v-if="scope.row.accountStatus === 0">{{$t('lang.AccountMng_status[1].name')}}</span>
            <!-- 1: 正常 -->
            <span v-if="scope.row.accountStatus === 1">{{$t('lang.AccountMng_status[2].name')}}</span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" >
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row)">{{$t('lang.btn_edit')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 新增编辑 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="600px"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px" label-suffix=":">
        <!-- 使用者 -->
        <el-form-item prop="userName" :label="$t('lang.lab_user')">
          <input style="display: none"/>
          <el-input v-model="form.userName" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_user')" maxlength="10"></el-input>
        </el-form-item>
        <!-- 账号 -->
        <el-form-item prop="accountNumber" :label="$t('lang.lab_account')">
          <input style="display: none"/>
          <el-input v-model="form.accountNumber" @input="keyAccountNumber" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_account')" maxlength="10"></el-input>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item prop="password" :label="$t('lang.lab_password')">
          <input style="display: none"/>
          <el-input v-model="form.password" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_password')" maxlength="16"></el-input>
        </el-form-item>
        <!-- 状态 -->
        <el-form-item prop="accountStatus" :label="$t('lang.lab_isStatus')">
          <el-select v-model="form.accountStatus" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_isStatus')">
            <el-option
              v-for="(item,index) in status"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="toCancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="toSave('form')" :disabled="isDisabled">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog>     
  </div>
</template>

<script>
/**
 *@ClassName:accountList
 *@Description:账号管理
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-16
 */
export default {
  name: '',
  components: {},
  data() {
    // 密码
    var passwordValue = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
    var passwordCheck = (rule, value, callback) => {
      if (this.form.password === '*******') {
        callback()
      } else if (this.form.password === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_password')))
      } else if (!passwordValue.test(value)) {
        this.$message.error(this.$i18n.t('lang.warning_passwordRule'))
        callback(new Error(this.$i18n.t('lang.warning_passwordNotOK')))
      } else {
        callback()
      }
    }
    // 账号
    var accountNumberValue = /^[A-Za-z0-9]+$/
    var accountNumberCheck = (rule, value, callback) => {
      if (this.form.accountNumber === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_account')))
      } else if (!accountNumberValue.test(value)) {
        callback(new Error(this.$i18n.t('lang.warning_accountNotOK')))
      } else {
        callback()
      }
    }
    
    return {
      isShow: false, // 新增编辑dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_add'), // 新增编辑dialog的title
      isDisabled: true, // 确定按钮置灰
      /* 账号管理列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      tableData: [], // 列表数据
      keyword: '', // 筛选-关键字
      /* 记忆筛选项值 */
      keyword_bak: '', // 备份-关键字
      /* 账号管理详情(新建编辑)变量 */
      rules: {
        userName: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_user'), trigger: 'blur' }],
        // accountNumber: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_account'), trigger: 'blur' }],
        accountNumber: [{ required: true, validator: accountNumberCheck, trigger: 'blur' }],
        password: [{ required: true, validator: passwordCheck, trigger: 'blur' }],
        accountStatus: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_isStatus'), trigger: 'change' }],
      },
      status: this.$i18n.t('lang.AccountMng_status'), // 状态下拉list
      form: {
        id: '',
        userName: '',
        accountNumber: '',
        password: '',
        accountStatus: '',
      }, // 详细数据
    }
  },
  computed: {},
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取账号列表数据
    getData() {
      this.$get(`/user/account?pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag, isSearch) { 
      if (flag) {
        this.pageNum = 1
      }
      if (isSearch) {
        // 记忆筛选项值
        this.keyword_bak = this.keyword
      } else { 
        // 筛选项正确显示
        this.keyword = this.keyword_bak
      }
      this.$get(`/user/account?keyWord=${this.keyword}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 新增
    onAdd() {
      console.log('onAdd')
      this.isTitle = this.$i18n.t('lang.btn_add')
      this.form.id = ''
      this.form.userName = ''
      this.form.accountNumber = ''
      this.form.password = ''
      this.form.accountStatus = ''
      this.isShow = true
    },
    // 删除
    onDelete() {
      console.log('onDelete')
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].id)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOneDelete'))
        return        
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`/user/account/${array}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_delSuccess')
                })
                // 更新tableData
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })  
    },
    // 编辑
    onEdit(data) {
      console.log('onEdit', data)
      this.isTitle = this.$i18n.t('lang.btn_edit')
      this.form.id = data.id
      this.form.userName = data.userName
      this.form.accountNumber = data.accountNumber
      this.form.password = '*******'
      this.form.accountStatus = data.accountStatus
      // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
      this.saveData = JSON.stringify(this.form)
      this.isShow = true
    },
    // 保存
    toSave(formName) {
      console.log('toSave')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.password === '*******') {
            this.form.password = ''
          }
          let params = this.form
          this.$postJson('/user/account', params).then(
            res => {
              console.log(res)
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_modifySuccess')
                })
                this.handleDialogClosed()
                // 更新列表
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 取消
    toCancel() {
      console.log('toCancel')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.userName = ''
      this.form.accountNumber = ''
      this.form.password = ''
      this.form.accountStatus = ''
    },
    // 监听关闭'新建编辑'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.userName = ''
      this.form.accountNumber = ''
      this.form.password = ''
      this.form.accountStatus = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false, false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false, false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      console.log('多选', val)
      this.multipleSelection = val
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 验证账号
    keyAccountNumber() {
      // 仅保留字母和数字
      // this.form.accountNumber = this.form.accountNumber.replace(/[^a-zA-Z0-9]/g, '') 
    }
  },
  created() {
    this.getData()
  },
  mounted() {}
}
</script>

<style lang='scss'>
</style>
